export const filterGroups = [
  {
    name: 'Subjects',
    key: 'subjects',
    filters: [
      { id: 1, name: 'Mathematics', checked: false },
      { id: 2, name: 'Language & Communication', checked: false },
      { id: 3, name: 'Arts & Crafts', checked: false },
      { id: 4, name: 'Environmental Education', checked: false },
      { id: 5, name: 'Physical Education', checked: false },
      { id: 6, name: 'Music', checked: false }
    ]
  },
  {
    name: 'Formats',
    key: 'types',
    filters: [
      { id: 1, name: 'Printables', checked: false },
      { id: 2, name: 'Activities', checked: false },
      { id: 3, name: 'Story Time', checked: false },
      { id: 4, name: 'Songs and Music', checked: false },
      { id: 5, name: 'Videos', checked: false },
      { id: 6, name: 'Games and Apps', checked: false }
    ]
  },
  {
    name: 'Curricular Years',
    key: 'grades',
    filters: [
      { id: 1, name: 'Nursery', checked: false },
      { id: 2, name: 'Pre-School', checked: false },
      { id: 3, name: 'Pre-Kindergarten', checked: false },
      { id: 4, name: 'Kindergarten', checked: false }
    ]
  },
  {
    name: 'Group Size',
    key: 'groupings',
    filters: [
      { id: 1, name: 'Individual', checked: false },
      { id: 2, name: 'Pairs', checked: false },
      { id: 3, name: 'Small groups', checked: false },
      { id: 4, name: 'Large Groups', checked: false }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/store/data/resourceFilters.js